import { Component, Host, h, Prop } from '@stencil/core';
export class Cell {
  getCellStyle() {
    const style = {};
    if (this.rowStart) {
      style.gridRowStart = this.rowStart;
    }
    if (this.colStart) {
      style.gridColumnStart = this.colStart;
    }
    if (this.height) {
      style.gridRowEnd = `span ${this.height}`;
    }
    if (this.width) {
      style.gridColumnEnd = `span ${this.width}`;
    }
    return style;
  }
  render() {
    return (h(Host, { style: this.getCellStyle() },
      h("slot", null)));
  }
  static get is() { return "sy-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "rowStart": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the position of the first row of the cell."
      },
      "attribute": "row-start",
      "reflect": true
    },
    "colStart": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the position of the first column of the cell."
      },
      "attribute": "col-start",
      "reflect": true
    },
    "height": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the height in rows of the cell."
      },
      "attribute": "height",
      "reflect": false
    },
    "width": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the width in columns of the cell."
      },
      "attribute": "width",
      "reflect": false
    }
  }; }
}
